import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
export default {
  name: 'groupbuy_vip_product',
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '拼团VIP产品',
        addFunName: 'groupBuyVipProductAdd',
        modifyFunName: 'groupBuyVipProductModify',
        delFunName: 'groupBuyVipProductDel',
        queryFunName: 'groupBuyVipProductQuery',
        detailFunName: 'groupBuyVipProductDetail',
        onlineFunName: 'groupBuyVipProductOnline',
        unOnlineFunName: 'groupBuyVipProductUnOnline'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        name: null,
        logo: null,
        originalCost: null,
        currentCost: null,
        vipDuration: null,
        vipDurationUnit: 'Month',
        firstSel: false,
        onlineState: false,
        remark: null
      },
      rules: {
        name: [{
          required: true,
          message: '产品名称不能为空',
          trigger: 'blur'
        }],
        originalCost: [{
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '现价必须为有效金额',
          trigger: 'blur'
        }],
        currentCost: [{
          required: true,
          message: '现价不能为空',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '现价必须为有效金额',
          trigger: 'blur'
        }],
        vipDuration: [{
          required: true,
          message: 'VIP时间不能为空',
          trigger: 'blur'
        }, {
          pattern: /^[1-9]\d*$/,
          message: 'VIP时间必须为正整数',
          trigger: 'blur'
        }],
        vipDurationUnit: [{
          required: true,
          message: 'VIP时间单位不能为空',
          trigger: 'blur'
        }],
        onlineState: [{
          required: true,
          message: '上架状态不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    online: function online(id) {
      var _this = this;
      this.$confirm('确定要上架吗').then(function () {
        _this.$api[_this.pageConfig.onlineFunName](id).then(function (res) {
          if (res.data) {
            _this.$message.success('上架成功');
            _this.query();
          } else {
            _this.$message.error('上架失败');
          }
        });
      });
    },
    unOnline: function unOnline(id) {
      var _this2 = this;
      this.$confirm('确定要下架吗').then(function () {
        _this2.$api[_this2.pageConfig.unOnlineFunName](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('下架成功');
            _this2.query();
          } else {
            _this2.$message.error('下架失败');
          }
        });
      });
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      if (paramData.originalCost) {
        paramData.originalCost = (paramData.originalCost / 100).toFixed(2);
      }
      if (paramData.currentCost) {
        paramData.currentCost = (paramData.currentCost / 100).toFixed(2);
      }
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      if (saveFormData.originalCost) {
        saveFormData.originalCost = parseInt(saveFormData.originalCost * 100);
      }
      if (saveFormData.currentCost) {
        saveFormData.currentCost = parseInt(saveFormData.currentCost * 100);
      }
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this3.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this3.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this3.formData.logo = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.logo);
    },
    removeFile: function removeFile() {
      this.formData.logo = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this4 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this4.initFormData(res.data);
        _this4.editDialogTitle = _this4.pageConfig.editPageName + '维护';
        _this4.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this5 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this5.$api[_this5.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this5.$message.success('删除成功');
            _this5.query();
          } else {
            _this5.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this6 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this6.tableData = res.data || [];
        _this6.totalCount = res.count;
        _this6.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this7 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this7.formData.id) {
            _this7.$api[_this7.pageConfig.modifyFunName](_this7.saveFormDataProcess(_this7.formData)).then(function (res) {
              if (res.data) {
                _this7.$message.success('编辑成功');
                _this7.initFormData(_this7.emptyFormData);
                _this7.editDialogShow = false;
                _this7.query();
              } else {
                _this7.$message.error('编辑失败');
              }
            });
          } else {
            _this7.$api[_this7.pageConfig.addFunName](_this7.saveFormDataProcess(_this7.formData)).then(function (res) {
              if (res.data) {
                _this7.$message.success('新增成功');
                _this7.initFormData(_this7.emptyFormData);
                _this7.editDialogShow = false;
                _this7.query();
              } else {
                _this7.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};